import data from "../../../../../src/Spinner.docs.json";
import * as React from 'react';
export default {
  data,
  React
};